<template>
  <div class="video_box_s">
    <div class="video_box">
      <div class="audiotitlex">
        <div class="img_box">
          <img class="img_box" src="@/assets/icon/shipin.png" />
        </div>
        <div class="fileName_box">{{ fileName }}</div>
      </div>
      <div class="video_con" @contextmenu.prevent="menuPlayer()">
        <video-player
          v-if="goodsFilePath"
          class="video-player vjs-custom-skin"
          ref="videoPlayer"
          :playsinline="true"
          :options="playerOptions"
        ></video-player>
      </div>
    </div>
  </div>
</template>
<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
export default {
  components: {
    videoPlayer,
  },
  computed: {
    playerOptions() {
      // 使用计算属性
      const playerOptionsObj = {
        playbackRates: [0.5, 0.8, 1.0, 1.5, 2.0, 3.0, 5.0], //播放速度
        autoplay: false, // 如果true,浏览器准备好时开始回放。
        muted: false, // 默认情况下将会消除任何音频。
        loop: false, // 导致视频一结束就重新开始。
        preload: "auto", // 建议浏览器在<video>加载元素后是否应该开始下载视频数据。auto浏览器选择最佳行为,立即开始加载视频（如果浏览器支持）
        language: "zh-CN",
        aspectRatio: "16:9", // 将播放器置于流畅模式，并在计算播放器的动态大小时使用该值。值应该代表一个比例 - 用冒号分隔的两个数字（例如"16:9"或"4:3"）
        fluid: false, // 当true时，Video.js player将拥有流体大小。换句话说，它将按比例缩放以适应其容器。
        sources: [
          {
            type: "video/" + this.fileType, // 资源格式写法：'video/mp4'，否则控制台会出现notSupportedMessage设置的错误
            src: this.goodsFilePath, // url地址
          },
        ],
        poster: "", // 你的封面地址
        notSupportedMessage: "此视频暂无法播放...", // 允许覆盖Video.js无法播放媒体源时显示的默认信息。
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: false,
          fullscreenToggle: true, //全屏按钮
        },
      };
      return playerOptionsObj;
    },
  },
  data() {
    return {
      fileName: "",
      goodsFilePath: "", //需要传递的参数(资源文件路径)
      loading: false,
      fileType: "mp4",
    };
  },
  created() {
    $(document).ready(function () {
      $("#video").bind("contextmenu", function () {
        return false;
      });
    });
  },
  methods: {
    tabbook(item, index, filePath) {
      this.loading = this.$loading({
        lock: true,
      });
      this.fileName = item.sourceName;
      this.goodsFilePath = filePath;
      this.loading.close();
    },
  },
};
</script>

<style scoped>
.video_box_s {
  overflow: hidden;
}
.video_box {
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  overflow: hidden;
  background: #fffefd;
  min-height: 95vh;
}

.video_boxt {
  width: 100%;
  float: left;
  font-size: 14px;
  padding: 0 20px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 41px;
  margin-bottom: 30px;
  height: 41px;
  border-bottom: 1px solid #f2f2f2;
}

.video_con {
  width: 100%;
  height: 90vh;
  margin: 0 auto;
  text-align: center;
}
.course_node_video ::v-deep .vjs-progress-control {
  pointer-events: none;
}
::v-deep .vjs-time-tooltip {
  width: 50px;
}
/* //video */
video::-internal-media-controls-download-button {
  display: none;
}

video::-webkit-media-controls-enclosure {
  overflow: hidden;
}

video::-webkit-media-controls-panel {
  width: calc(100% + 30px);
}
/* //audio */
audio::-internal-media-controls-download-button {
  display: none;
}
audio::-webkit-media-controls-enclosure {
  overflow: hidden;
}
audio::-webkit-media-controls-panel {
  width: calc(100% + 35px);
}
::v-deep .vjs-big-play-button {
  left: 50%;
  top: 50%;
  margin-left: -45px;
  margin-top: -22.5px;
}
.img_box {
  width: 20px;
  height: 20px;
  background: #666666;
}
.audiotitlex {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 5px 15px;
  border-bottom: 1px solid #f2f2f2;
  padding: 5px;
}
.fileName_box {
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 26px;
}
</style>
